import { useTranslation } from "react-i18next";
import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import {Layout, Tabs, TabsProps} from "antd";
import {Editor} from "grapesjs";
import {isEmpty} from "lodash";
import {useEffect, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import CourseContentPage from "../../../../../components/course-content";
import PageHeader from "../../../../../components/page-header/PageHeader";
import {routesConfig} from "../../../../../config/routes";
import {getTemplateByCourseId} from "../../../../../service/page-builder/page-builder";
import "./index.scss";
import IntroductionPage from "./introduction-page";
import BrowsingResults from "../../../../../components/course-construction/assign-course-construction/browsing-results";
import {getAllStatusReviewCourse} from "../../../../../service/content-course/contenCourseApi";
import ActionCourseHistory from "../../action-course-history";

const imgPath = "/images/";
const {Content} = Layout;

export default function DetailCourseEvaluation() {
  const { t } = useTranslation();
  const location = useLocation();
  const [activeSvg, setActiveSvg] = useState("pc");
  const [template, setTemplate] = useState<any>();
  const [tab, setTab] = useState<string>("1");
  const [detailData, setDetailData] = useState<any>()

  const navigate = useNavigate()

  const listBreadcrumb = [
    {
      title: t("Xây dựng khoá học", "Xây dựng khoá học"),
    },
    {
      title: (
        <a
          href={`/course-construction/${routesConfig.courseBrowse}/${routesConfig.courseEvaluation}`}
        >{t("Thẩm định khoá học", "Thẩm định khoá học")}</a>
      ),
    },
    {
      title: location.state.name,
    },
  ];

  const params = useParams();

  const getDetailCourseData = async () => {
    await getAllStatusReviewCourse(params?.id).then(res => {
      setDetailData(res.data.data)
    })
  }

  useEffect(() => {
    getDetailCourseData()
  }, [])

  useEffect(() => {
    if (location.state?.tab) {
      setTab("2")
    }
  }, [navigate])

  const reloadAllTemplate = (editor: Editor, objTemplate: string) => {
    const parseCourseSavedTempalte = JSON.parse(objTemplate);
    editor.setComponents(parseCourseSavedTempalte.html);
    editor.setStyle(parseCourseSavedTempalte.css);
  };

  const getDetailTemplatesByCoueseId = (cb?: any) => {
    getTemplateByCourseId(params?.id).then((res) => {
      const {data} = res.data;
      cb && cb(data);
    });
  };

  const onEditor = (editor: Editor) => {
    getDetailTemplatesByCoueseId((res: any) => {
      if (!isEmpty(res)) {
        reloadAllTemplate(editor, res.template);
      }
    });
  };

  const items: TabsProps["items"] = [
    {
      key: "1",
      // icon: <UserOutlined />,
      label: t("Trang giới thiệu", "Trang giới thiệu"),
      children: (
        <div className="wrapper-approve-page">
          <section className="introduction-page disabled-overflow">
            <div className="form-detail">
              <IntroductionPage mode={location.state?.mode} setTab={setTab} tab={tab}/>
            </div>
          </section>
        </div>
      ),
    },
    {
      key: "2",
      // icon: <HistoryOutlined />,
      label: t("Nội dung khoá học", "Nội dung khoá học"),
      children: (
        <div className="wrapper-approve-page">
          <section className="">
            <div className="form-detail disabled-overflow">
              <CourseContentPage setTab={setTab} tab={tab} getDetailData={getDetailCourseData}
                                 detailDataProps={detailData}/>
            </div>
          </section>
        </div>
      ),
    },
    {
      key: "3",
      // icon: <LockOutlined />,
      label: t("Kết quả duyệt", "Kết quả duyệt"),
      children: (
        <div className="">
          <section className="course-browse">
            <div className="form-detail">
              <BrowsingResults planInfo={location.state} detailData={detailData}/>
            </div>
          </section>
        </div>
      ),
    },
    {
      key: "4",
      // icon: <LockOutlined />,
      label: t("Lịch sử thao tác", "Lịch sử thao tác"),
      children: (
        <div className="wrapper-approve-page disabled-overflow">
          <section className="">
            <div className="form-detail">
              <ActionCourseHistory/>
            </div>
          </section>
        </div>
      ),
    },
  ];

  return (
    <Layout>
      <Content className="course-browse-detail">
        <PageHeader
          title={`${t("Thẩm định khoá học", "Thẩm định khoá học")} ${location.state.nameCourse}`}
          // subTitle={t("Thẩm định khoá học", "Thẩm định khoá học")}
          listBreadcrumb={listBreadcrumb}
          arrowLeft={imgPath + "arrowLeft.svg"}
          positionItem="column"
          breadcrumb={true}
        />
        <div className="tabs-heading">
          <Tabs
            defaultActiveKey="1"
            items={items}
            activeKey={tab}
            onChange={setTab}
          />
        </div>
      </Content>
    </Layout>
  );
}
